import InstagramEmbed from './InstagramEmbed';

export { InstagramEmbed };
